import apiClient from '@src/api/clients';

const URL = 'app1/facebook-pages/';

/** Pages, optionally for one client. Inactive Pages are hidden unless asked for. */
export const listFacebookPages = ({ client, includeInactive } = {}) =>
  apiClient.request({
    url: URL,
    method: 'GET',
    payload: {
      ...(client ? { client } : {}),
      ...(includeInactive ? { include_inactive: '1' } : {}),
    },
  });

export const createFacebookPage = (payload) =>
  apiClient.request({ url: URL, method: 'POST', payload });

/** Nickname, name, tier or active. Which Page local ads use is set in the Local Ad Builder. */
export const updateFacebookPage = (id, payload) =>
  apiClient.request({ url: `${URL}${id}/`, method: 'PATCH', payload });
